<ng-container *ngIf="companyApplicant">
    <form #companyApplicantForm="ngForm" [attr.data-test-id]="testId + '.form'">
        <h3 class="section-title" [attr.data-test-id]="testId + '.title'">Business Details</h3>

        <div class="row">
            <div class="col-sm-10">
                <creditsnap-address id="companyApplicantAddress" [(ngModel)]="companyApplicant.address" name="address"
                                    #address (ngModelChange)="notifyChange()"
                                    [attr.data-test-id]="testId + '.address'"></creditsnap-address>
            </div>
            <div class="col-sm-2">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.unit-label'">Unit #</mat-label>
                    <input #unit="ngModel" [(ngModel)]="companyApplicant.address.addressLine2" autocomplete="new-unit" matInput
                           name="unit" type="text" (ngModelChange)="notifyChange()"
                           [attr.data-test-id]="testId + '.unit-input'"/>
                </mat-form-field>
            </div>
            <div class="col-sm-6">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.website-label'">Company Website</mat-label>
                    <input matInput type="text" name="companyWebsite" autocomplete="off"
                           [(ngModel)]="companyApplicant.companyWebSite" #companyWebsite="ngModel"
                           (ngModelChange)="notifyChange()"
                           [attr.data-test-id]="testId + '.website-input'">
                    <!--<mat-error *ngIf="companyWebsite.hasError('required')">Company Website is <strong>required.</strong></mat-error>-->
                    <mat-hint>If you do not have a website, then enter N/A into it</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-sm-6">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.business-type-label'">Type Of Business</mat-label>
                    <input type="text" #companySearch
                           (keyup)="onSearchChange($event, companySearch.value)"
                           (blur)="onCompanySearchBlur(companySearch.value)"
                           (ngModelChange)="onCompanyInputChange($event)"
                           autocomplete="one-time-code"
                           [placeholder]="'Start typing to search'"
                           name="companyIndustry"
                           matInput
                           [(ngModel)]="selectedCompanyTitle"
                           [matAutocomplete]="companyAutocomplete"
                           #companyIndustry="ngModel"
                           required
                           [attr.data-test-id]="testId + '.business-type-input'">
                    <mat-autocomplete #companyAutocomplete="matAutocomplete" autoActiveFirstOption (optionSelected)="selectCompany($event)"
                                      [attr.data-test-id]="testId + '.business-type-autocomplete'">
                        <mat-option *ngFor="let company of companies" [value]="company.title"
                                    [attr.data-test-id]="testId + '.business-type-option.' + company.id">
                            {{ company.title }}
                        </mat-option>
                        <mat-option *ngIf="min3Chars" disabled [attr.data-test-id]="testId + '.business-type-min-chars'">Type minimum 3 characters</mat-option>
                        <mat-option *ngIf="companySearching" disabled [attr.data-test-id]="testId + '.business-type-searching'">Searching ...</mat-option>
                        <mat-option *ngIf="noCompanies" disabled [attr.data-test-id]="testId + '.business-type-no-results'">No data available</mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="companyIndustry.hasError('required')" [attr.data-test-id]="testId + '.business-type.required-error'">Please enter the type of business.</mat-error>
                </mat-form-field>
            </div>

            <!--₹  *ngIf="keyIdentifier.loanPurposeConfig?.companyInfo?.businessPhone" -->
            <div class="col-sm-6">
                <creditsnap-phone-number name="contactNumber" [(ngModel)]="companyApplicant.primaryPhone"
                                         [placeholder]="'Business Phone Number'" [options]="phoneInputOptions"
                                         [id]="'business-phone-number'" #contactNumber
                                         (ngModelChange)="notifyChange()"
                                         [attr.data-test-id]="testId + '.phone-number'">
                </creditsnap-phone-number>
            </div>
            <div class="col-sm-6">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.business-details-label'">Business Details</mat-label>
                    <input matInput type="text" name="businessDescription"
                           autocomplete="off" [(ngModel)]="companyApplicant.businessDescription" #businessDescription="ngModel"
                           (ngModelChange)="notifyChange()" required
                           [attr.data-test-id]="testId + '.business-description-input'">
                    <mat-error *ngIf="businessDescription.hasError('required')" [attr.data-test-id]="testId + '.business-description.required-error'">Please enter a description.</mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-6">
                <creditsnap-date name="dateOfBirth" [label]="'Date of organization formation'"
                                 [maxDate]="maxDate" [minDate]="minDate"
                                 [(ngModel)]="companyApplicant.dateOfBirth" #dateOfBirth
                                 (ngModelChange)="notifyChange()"
                                 [attr.data-test-id]="testId + '.formation-date'"></creditsnap-date>
            </div>

            <!-- Business mailing address (collected against the business, not the business contact) -->
            <ng-container *ngIf="showBusinessMailingAddress">
                <div class="col-sm-12 text-start mt-3 mb-2">
                    <mat-checkbox name="sameBusinessMailAddress" [(ngModel)]="sameBusinessMailAddress"
                                  (ngModelChange)="notifyChange()"
                                  [attr.data-test-id]="testId + '.same-business-mailing-address-checkbox'">
                        Business mailing address is same as the business address provided above
                    </mat-checkbox>
                </div>
                <ng-container *ngIf="!sameBusinessMailAddress">
                    <div class="col-sm-10">
                        <creditsnap-address id="businessMailingAddress" name="businessMailingAddress"
                                            [(ngModel)]="businessMailingAddressData" [isMailingAddress]="true"
                                            (ngModelChange)="notifyChange()"
                                            [attr.data-test-id]="testId + '.business-mailing-address'"></creditsnap-address>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.business-mailing-unit-label'">Unit #</mat-label>
                            <input [(ngModel)]="businessMailingAddressData.addressLine2" autocomplete="new-unit" matInput
                                   name="businessMailingUnit" type="text" (ngModelChange)="notifyChange()"
                                   [attr.data-test-id]="testId + '.business-mailing-unit-input'"/>
                        </mat-form-field>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </form>
</ng-container>
